import { type RouteObject } from 'react-router-dom';

import { RootNavigate } from '@/components';
import { ROUTES_PATH } from '@/constants/routes.constants';

import { AccountRoutes } from './account/routes';
import { BannerRoutes } from './banner/routes';
import { ChangePasswordRoutes } from './change-password/routes';
import { DrinkRoutes } from './drink/routes';
import { FaqRoutes } from './faq/routes';
import { Features as FeaturesComponent } from './features-component';
import { loader as featureLoader } from './features-loader';
import { FullIpLabelsRoutes } from './full-ip-label/routes';
import { IPLabelRoutes } from './ip-label/routes';
import { LabelOrderRoutes } from './label-order/routes';
import { OrganizationRoutes } from './organization/routes';
import { SalesPerformanceRoutes } from './sales-performance/routes';
import { ShopRoutes } from './shop/routes';
import { SnapLabelRoutes } from './snap-label/routes';
import { UsageGuideRoutes } from './usage-guide/routes';

export const FeaturesRoutes: RouteObject[] = [
  {
    id: 'features',
    loader: featureLoader,
    path: ROUTES_PATH.root,
    element: <FeaturesComponent />,
    children: [
      { index: true, element: <RootNavigate /> },
      ...OrganizationRoutes,
      ...ShopRoutes,
      ...SalesPerformanceRoutes,
      ...AccountRoutes,
      ...ChangePasswordRoutes,
      ...UsageGuideRoutes,
      ...FaqRoutes,
      ...DrinkRoutes,
      ...BannerRoutes,
      ...IPLabelRoutes,
      ...LabelOrderRoutes,
      ...SnapLabelRoutes,
      ...FullIpLabelsRoutes,
    ],
  },
];
